import { Grid, withStyles, WithStyles } from '@material-ui/core'
import { Fragment, FC, useEffect, useRef } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { openDialog } from '../../actions/dialogs'
import {
  changePassword,
  updateUserInformation,
  logout
} from '../../actions/users'
import Container from '../../components/Container'
import { objectNotEmpty } from '../../libs/objects'
import {
  selectIsAdminUser,
  selectUserAttributes,
  selectUserIsAuthenticated
} from '../../selectors/users'
import { UserAttributes } from '../../services/auth/types'
import { profileStyles } from '../../styles'
import { StateInterface } from '../../types/states'
import { bindSubmitActionToPromise } from '../../utils/forms'
import { reportSpecificKeywordUsageTalkJs } from '../../utils/talkChat'

const mapStateToProps = (state: StateInterface) => {
  const stateUserAttributes = selectUserAttributes(state)
  return {
    isAdmin: selectIsAdminUser(state),
    isAuthenticated: selectUserIsAuthenticated(state),
    userAttributes: objectNotEmpty<UserAttributes>(stateUserAttributes)
      ? stateUserAttributes
      : undefined
  }
}

type PropsFromState = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateUserInfo: bindSubmitActionToPromise(dispatch, updateUserInformation),
  changeUserPassword: bindSubmitActionToPromise(dispatch, changePassword),
  openDialogAction: (id: string) => dispatch(openDialog(id)),
  logoutUser: () => dispatch(logout())
})

type DispatchProps = ReturnType<typeof mapDispatchToProps>

type MessageProps = PropsFromState &
  DispatchProps &
  WithTranslation &
  WithStyles

const Messages: FC<MessageProps> = ({
  isAdmin,
  isAuthenticated,
  classes,
  userAttributes,
  t
}: MessageProps) => {
  console.log('Chat Initialize.')
  const containerRef = useRef<HTMLDivElement>(null)

  /* eslint-disable react-hooks/rules-of-hooks */
  useEffect(() => {
    if (userAttributes?.email && window.talkSession) {
      const inboxInstance = window.talkSession.createInbox()

      // Mount the inbox UI ReCommit
      if (containerRef.current) {
        inboxInstance.mount(containerRef.current)
      }

      // Listen for outgoing messages
      window.talkSession.on("message", (event: any) => {
        if (event.type === "text") {
          // call your custom function here
          reportSpecificKeywordUsageTalkJs({
            conversation: {
              id: event.conversation.id
            },
            message: {
              text: event.body
            }
          })
        }
      })
    }
  }, [userAttributes])

  return (
    <Fragment>
      <Container>
        <Grid container justify='space-around' style={{ paddingTop: '24px' }}>
          <Grid container direction='row' justify='space-evenly'>
            <Grid item md={12} lg={12} xl={10} xs>
              {isAuthenticated && (
                <div
                  style={{ height: '500px' }}
                  className='inbox-container'
                  ref={containerRef}
                >
                  Loading...
                </div>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(profileStyles)(withTranslation()(Messages)))
